import { BACKEND_DOMAIN, QUERY_STALE_TIME } from "utils/constants";
import { buildRequestHeaders, showMutationAlert } from "utils/helpers";
import useAlert from "hooks/useAlert";
import { useAccessToken } from "hooks/useAccessToken";
import { useQuery } from "react-query";

export const buildingQueryKey = ["buildingModel"];

const useQueryBuilding = (buildingModelUid: string) => {
    const alert = useAlert();
    const accessToken = useAccessToken();
    const URL = `${BACKEND_DOMAIN}/buildings/${buildingModelUid}`

    return useQuery<Building>({
        queryKey: [...buildingQueryKey, buildingModelUid], 
        queryFn: async () => {
            const response = await fetch(URL, {
                method: "GET",
                headers: buildRequestHeaders(accessToken),
            });
            if (!response.ok) {
                throw new Error(`Error ${response.status}`);
            }
            return response.json();
        },
        onError: (error) => {
            showMutationAlert(error, alert);
        },
        staleTime: QUERY_STALE_TIME,
        enabled: !!buildingModelUid,
    });
}

export default useQueryBuilding;
